import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#FAFBFC] py-20">
      <div className="max-w-4xl mx-auto px-6">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium mb-8 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Torna alla home
        </Link>

        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">
          Privacy Policy
        </h1>

        <div className="prose prose-gray max-w-none">
          <p className="text-gray-500 mb-8">
            Ultimo aggiornamento: Aprile 2026
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">1. Titolare del Trattamento</h2>
            <p className="text-gray-600 leading-relaxed">
              Il Titolare del trattamento dei dati personali è <strong>SeagullByte</strong>, con sede legale in Italia, 
              P.IVA 01295100950, contattabile all'indirizzo email: <a href="mailto:info@seagullbyte.it" className="text-blue-600 hover:underline">info@seagullbyte.it</a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">2. Tipologie di Dati Raccolti</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Attraverso il modulo di contatto presente sul sito, raccogliamo i seguenti dati personali:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li><strong>Nome</strong> - per identificare l'utente e personalizzare la comunicazione</li>
              <li><strong>Indirizzo Email</strong> - per rispondere alle richieste e inviare comunicazioni</li>
              <li><strong>Numero di Telefono</strong> (opzionale) - per contatti telefonici se richiesto</li>
              <li><strong>Nome Azienda</strong> (opzionale) - per comprendere il contesto professionale</li>
              <li><strong>Messaggio</strong> (opzionale) - per comprendere le esigenze specifiche dell'utente</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">3. Finalità del Trattamento</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              I dati personali sono trattati per le seguenti finalità:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li><strong>Rispondere alle richieste di contatto</strong> - Base giuridica: esecuzione di misure precontrattuali (Art. 6.1.b GDPR)</li>
              <li><strong>Fornire informazioni sui nostri servizi</strong> - Base giuridica: legittimo interesse (Art. 6.1.f GDPR)</li>
              <li><strong>Adempiere ad obblighi legali</strong> - Base giuridica: obbligo legale (Art. 6.1.c GDPR)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">4. Base Giuridica del Trattamento</h2>
            <p className="text-gray-600 leading-relaxed">
              Il trattamento dei dati personali si basa sul <strong>consenso esplicito</strong> dell'interessato (Art. 6.1.a GDPR), 
              espresso mediante la spunta della casella di accettazione della presente Privacy Policy prima dell'invio del modulo di contatto.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">5. Modalità di Trattamento</h2>
            <p className="text-gray-600 leading-relaxed">
              I dati personali sono trattati con strumenti automatizzati e non automatizzati, con logiche strettamente correlate 
              alle finalità sopra indicate e, comunque, in modo da garantire la sicurezza e la riservatezza dei dati stessi, 
              nel rispetto delle misure di sicurezza previste dal GDPR (Art. 32).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">6. Conservazione dei Dati</h2>
            <p className="text-gray-600 leading-relaxed">
              I dati personali saranno conservati per il tempo strettamente necessario a conseguire le finalità per cui sono stati raccolti, 
              e comunque per un periodo non superiore a <strong>24 mesi</strong> dalla raccolta, salvo obblighi di legge che ne richiedano 
              una conservazione più lunga.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">7. Comunicazione e Diffusione dei Dati</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              I dati personali non saranno diffusi. Potranno essere comunicati a:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li>Soggetti che forniscono servizi per la gestione del sistema informativo (hosting, database)</li>
              <li>Autorità competenti, per adempimenti di obblighi di legge</li>
              <li>Collaboratori e dipendenti del Titolare, nei limiti delle rispettive mansioni</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">8. Trasferimento dei Dati</h2>
            <p className="text-gray-600 leading-relaxed">
              I dati personali sono conservati su server situati nell'Unione Europea. Nel caso di trasferimento verso paesi terzi, 
              questo avverrà solo verso paesi che garantiscono un livello di protezione adeguato o sulla base di appropriate garanzie 
              (Clausole Contrattuali Standard approvate dalla Commissione Europea).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">9. Diritti dell'Interessato</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              In conformità agli articoli 15-22 del GDPR, l'interessato ha diritto di:
            </p>
            <ul className="list-disc pl-6 text-gray-600 space-y-2">
              <li><strong>Accesso</strong> - ottenere conferma dell'esistenza di dati che lo riguardano</li>
              <li><strong>Rettifica</strong> - ottenere la correzione dei dati inesatti</li>
              <li><strong>Cancellazione</strong> - ottenere la cancellazione dei dati ("diritto all'oblio")</li>
              <li><strong>Limitazione</strong> - ottenere la limitazione del trattamento</li>
              <li><strong>Portabilità</strong> - ricevere i dati in formato strutturato e leggibile</li>
              <li><strong>Opposizione</strong> - opporsi al trattamento per motivi legittimi</li>
              <li><strong>Revoca del consenso</strong> - revocare il consenso in qualsiasi momento</li>
            </ul>
            <p className="text-gray-600 leading-relaxed mt-4">
              Per esercitare i propri diritti, l'interessato può inviare una richiesta a: <a href="mailto:info@seagullbyte.it" className="text-blue-600 hover:underline">info@seagullbyte.it</a>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">10. Reclamo all'Autorità di Controllo</h2>
            <p className="text-gray-600 leading-relaxed">
              L'interessato ha diritto di proporre reclamo al <strong>Garante per la Protezione dei Dati Personali</strong> 
              (www.garanteprivacy.it) qualora ritenga che il trattamento dei propri dati personali sia contrario alla normativa vigente.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">11. Modifiche alla Privacy Policy</h2>
            <p className="text-gray-600 leading-relaxed">
              Il Titolare si riserva il diritto di modificare questa Privacy Policy in qualsiasi momento. 
              Le modifiche saranno pubblicate su questa pagina con indicazione della data di ultimo aggiornamento.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
